import React, { useContext, useState } from "react";
import { Checkbox } from "../view/Checkbox";
import { deepCopy, formatReportDate, getInitials } from "../utils";
import { PopupContext, TableContext } from "../index";
import { downloadReport, deleteReports, viewReport } from "./reportService";
import { showDangerToast, showSuccessToast } from "../validation/ToastContainer";
import { getDeletePopup } from "../view/popup/PopupContainer";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import { MoreVertical, Eye, Download, Trash2 } from 'lucide-react';


function ReportsTableRow({ data, index }) {

    const { config, setConfig } = useContext(TableContext);
    const { setPopup } = useContext(PopupContext);

    const onCheckboxChange = () => {
        let selectedRows = deepCopy(config.selected);
        if (selectedRows.includes(data.id)) {
            selectedRows.splice(selectedRows.indexOf(data.id), 1);
        } else {
            selectedRows.push(data.id)
        }
        setConfig({ ...config, selected: selectedRows })
    }

    // MUI Menu state
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const onDownloadClick = () => {
        handleClose();
        downloadReport(data);
    };

    const handleViewClick = () => {
        handleClose();
        viewReport(data);
    };

    const handleDeleteClick = () => {
        handleClose();
        setPopup(getDeletePopup(
            'Are you sure you want to delete this report?',
            'Delete Report',
            confirmDelete,
            undefined,
            'Delete Report'
        ));
    };
    const confirmDelete = () => {
        deleteReports([data.id])
            .then(() => {
                showSuccessToast('Report deleted successfully', 'Delete Report');
                setConfig({ ...config, lastUpdated: Date.now() });
            })
            .catch(() => {
                showDangerToast('Failed to delete report', 'Delete Report');
            });
    };

    return (
        <>
            <tr key={index}>
                <td>
                    <Checkbox checked={config.selected.includes(data.id)} onClick={() => onCheckboxChange()} />
                </td>
                <td>
                    <span className="oct_report-name">{data.name}</span>
                </td>
                <td>
                    <span className="oct_report-description">{data.description}</span>
                </td>
                <td>
                    <div className="oct_report-created-by">
                        <span className="oct_initials-badge">{getInitials(data.createdBy)}</span>
                        <span className="oct_creator-name">{data.createdBy}</span>
                    </div>
                </td>
                <td>
                    <span className="oct_report-date">{formatReportDate(data.date)}</span>
                </td>
                <td>
                    <button className="oct_dropdown-trigger-v2" onClick={handleClick}>
                        <MoreVertical className="oct_icon" />
                    </button>

                    <Menu
                        className="oct_menu-v2"
                        id="report-action-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleClose}>

                        <MenuItem className="oct_menu-item-v2" onClick={handleViewClick}>
                            <Eye className="oct_icon" /> View
                        </MenuItem>
                        <MenuItem className="oct_menu-item-v2" onClick={onDownloadClick}>
                            <Download className="oct_icon" /> Download PDF
                        </MenuItem>
                        <MenuItem className="oct_menu-item-v2 oct_menu-item-danger" onClick={handleDeleteClick}>
                            <Trash2 className="oct_icon" /> Delete
                        </MenuItem>

                    </Menu>
                </td>
            </tr>
        </>


    )



}

export default ReportsTableRow;
